import script from "./ClientIconsBeforeNameTargetTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientIconsBeforeNameTargetTooltip.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__